<div class="border-container bg-white  mb-3">
  <div class="header border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2 title">{{ 'Sellers.Products.ContactInfo' | translate }}</h3>
    </div>
  </div>
  <form [formGroup]="contactForm" *ngIf="contactForm">

    <div class="row">
      <div class="col-6 ml-3">
        <div class="mb-3">
          <label>{{ 'Sellers.Products.PhoneNumber' | translate }}</label>
              <div class="input-group">
                <input class="form-control" type="text"
                       placeholder="{{ 'Sellers.Products.PhoneNumber' | translate }}"
                       formControlName="phone" required [readonly]="phone_verified"/>
                <div [ngClass]="{ nopadding: !phone_verified }"
                     class="input-group-append input-verify">
                  <button class="btn text-light m-0 d-block"
                          style="color: white;
                      background-color: rgba(15, 117, 189, 1);
                     "
                          *ngIf="!phone_verified"
                          (click)="sendSMS()">
                    {{ 'Sellers.Products.Verify' | translate }}
                  </button>
                  <div class="mt-1"
                    *ngIf="phone_verified"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    style="color: green">
                    <mat-icon>done</mat-icon>
                    <span>{{ 'Sellers.Products.Verified' | translate }}</span>
                  </div>
                  <a *ngIf="phoneVerifyClicked && !phone_verified"
                     (click)="sendSMS()">{{ 'Sellers.Products.Resend' | translate }}</a>
                </div>
              </div>
              <small
                *ngIf="formValidator?.formErrors?.phone"
                class="text-danger">
                {{ formValidator.formErrors.phone }}
              </small>
        </div>
        <div class=" mb-3 d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.CustomerServiceEmail' | translate }}
          </label>
          <input class="form-control" type="email" placeholder="{{ 'Sellers.Products.CustomerServiceEmail' | translate }}"
            formControlName="cs_email" />
          <small *ngIf="formValidator.formErrors.cs_email" class="text-danger">
            {{ formValidator.formErrors.cs_email }}
          </small>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-3">
          <label>{{ 'Sellers.Products.Email' | translate }}</label>
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              placeholder="{{ 'Sellers.Products.Email' | translate }}"
              formControlName="email"
              required
              [readonly]="mail_verified"
              />
            <div
              [ngClass]="{ nopadding: !mail_verified }"
              class="input-group-append input-verify">
              <button class="btn text-light m-0 d-block"
                      style="color: white;
                      background-color: rgba(15, 117, 189, 1);
                      height: 100% !important;"
                      *ngIf="!mail_verified"
                      (click)="verify_email()">
                {{ 'Sellers.Products.Verify' | translate }}
              </button>
              <div class="mt-1"
                *ngIf="mail_verified"
                fxLayout="row"
                fxLayoutAlign="center center"
                style="color: green">
                <mat-icon>done</mat-icon>
                <span>{{ 'Sellers.Products.Verified' | translate }}</span>
              </div>
            </div>
          </div>
          <small
            *ngIf="formValidator?.formErrors?.email"
            class="text-danger">
            {{ formValidator.formErrors.email }}
          </small>
        </div>


        <div class="d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.CustomerServiceMobile' | translate }}
            <!-- <app-verify-icon iconColor="primary" verifyIconName='verified' class="icon-small" *ngIf="phoneStatus">
            </app-verify-icon> -->
          </label>
          <input class="form-control" type="tel" placeholder="{{ 'Sellers.Products.CustomerServiceMobile' | translate }}"
            formControlName="cs_phone" />
          <small *ngIf="formValidator.formErrors.cs_phone" class="text-danger">
            {{ formValidator.formErrors.cs_phone }}
          </small>
        </div>
      </div>
    </div>



    <div class=" subHeader border-top border-2">
      <div class="px-4">
        <h4 class="pt-2 title">{{ 'Sellers.Products.SocialMedia' | translate }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="mb-3 row">
          <div class="">
            <label *ngIf="!facebook_verified">
              {{ 'Sellers.Products.FacebookProfileLink' | translate }} <span class="text-danger">*</span>
            </label>
            <label *ngIf="facebook_verified">
              {{ 'Sellers.Products.FacebookVerified' | translate }}
            </label>
            <input class="form-control" type="url" formControlName="link_fb" [readonly]="facebook_verified" />
            <small *ngIf="formValidator.formErrors.link_fb" class="text-danger text-danger-hidden">
              {{ formValidator.formErrors.link_fb }}
            </small>
          </div>
        </div>

        <div class="form-group">
          <label>{{ 'Sellers.Products.InstagramAccount' | translate }}</label>
          <input
               formControlName="instagram"
                 type="url" class="form-control">
          <small class="text-danger" *ngIf="formValidator.formErrors.instagram">
            {{ formValidator.formErrors.instagram }}
          </small>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-3">
          <label>{{ 'Sellers.Products.Website' | translate }}</label>
          <input formControlName="website" type="text" class="form-control">
          <small class="text-danger" *ngIf="formValidator.formErrors.website">
            {{ formValidator.formErrors.website }}
          </small>
        </div>
        <div class="d-flex flex-column align-items-start">
          <label>
            {{ 'Sellers.Products.LinkedInProfileLink' | translate }}:
          </label>
          <input class="form-control" type="url" formControlName="link_li" />
          <small *ngIf="formValidator.formErrors.link_li" class="text-danger">
            {{ formValidator.formErrors.link_li }}
          </small>
        </div>

      </div>
    </div>
  </form>
</div>
